// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const vanillite: PokeData = {
  "id": 582,
  "name": "vanillite",
  "height": 4,
  "weight": 57,
  "base_experience": 61,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "mist",
    "ice-beam",
    "blizzard",
    "harden",
    "acid-armor",
    "icy-wind",
    "mirror-coat",
    "uproar",
    "hail",
    "taunt",
    "astonish",
    "sheer-cold",
    "icicle-spear",
    "avalanche",
    "mirror-shot"
  ],
  "moves": [
    "blizzard",
    "sheer-cold",
    "avalanche",
    "chilly-reception",
    "aurora-veil",
    "ice-punch",
    "ice-fang",
    "icicle-dagger",
    "ice-wave",
    "hailstorm",
    "ice-shard"
  ],
  "evolution_chain": {
    "id": 296,
    "item": null,
    "species": [
      {
        "name": "vanillite",
        "order": 583,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "vanillish",
        "order": 584,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 582,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "vanilluxe",
        "order": 585,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 583,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 47,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45.5,
    "speed": 44,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
